import React from 'react';
import { BrackedAddIcon } from '@/assets/icons/icons';

export const LabelWithPlus: React.FC<{
  text: string;
  required?: boolean;
  onPlusClick?: () => void;
}> = ({ text, required, onPlusClick }) => {
  return (
    <span className='agentFormLabelInline'>
      <span className='agentFormLabelText'>
        {text}
        {required && <span className='agentFormRequiredStar'>*</span>}
      </span>

      <span
        className='agentFormAddIconBtn'
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onPlusClick?.();
        }}
        role='button'
        tabIndex={0}
      >
        <BrackedAddIcon />
      </span>
    </span>
  );
};
